import { Divider } from 'antd';
import cuota from '../../../../assets/viability/cuota.png';
import interes from '../../../../assets/viability/interes.png';

const CondictionsLegal = () => {
	const renderFormulaCuota = () => (
		<span
			role="math"
			aria-label="Fórmula para el cálculo de la cuota"
			style={{
				fontSize: 12,
				display: 'inline-flex',
				alignItems: 'center',
				gap: 4,
				margin: '0px 4px'
			}}>
			<span>Cuota =</span>
			<span>N</span>
			<span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
				<span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 'italic' }}>
					<span style={{ fontStyle: 'italic' }}>
						( <span>1 + </span>
						<span>i/p</span> )<sup style={{ fontSize: '0.75em' }}>t*p</sup>
					</span>
					<span style={{ fontStyle: 'italic' }}>( i/p )</span>
				</span>
				<Divider style={{ margin: '1px 0px', borderColor: '#757575', width: 80 }} />
				<span style={{ fontStyle: 'italic' }}>
					({' '}
					<span>
						{' '}
						1 + <span>i/p</span>
					</span>{' '}
					) <sup style={{ fontSize: '0.75em' }}>t*p</sup>
					{' - '}1
				</span>
			</span>
		</span>
	);

	const renderFormulaInteresCuota = () => (
		<span
			role="math"
			aria-label="Fórmula para el cálculo del interés de la cuota"
			style={{
				fontSize: 12,
				fontFamily: 'serif',
				display: 'inline-flex',
				alignItems: 'center',
				gap: 4,
				margin: '0px 4px'
			}}>
			<span>Interés de la cuota =</span>
			<span>N</span>
			<span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
				<span style={{ fontStyle: 'italic' }}>i</span>
				<Divider style={{ margin: '1px 0px', borderColor: '#757575', width: 15 }} />
				<span style={{ fontStyle: 'italic' }}>p</span>
			</span>
		</span>
	);

	return (
		<span style={{ fontSize: 12 }}>
			Condiciones legales 1.Condiciones vigentes hasta el 05/02/2024. Consulta los ejemplos
			representativos de hipoteca mixta, variable y fija: Oferta válida solo para personas físicas
			(sin destino empresarial) residentes en España, con la excepción de la Comunidad Autónoma de
			Andalucía, que tengan ingresos y patrimonio solo en euros. Para una operación sobre vivienda a
			formalizar o celebrar en la Comunidad Autónoma de Andalucía, consulta en tu oficina la oferta
			especial existente. Ejemplos representativos conforme a lo previsto en la normativa legal
			aplicable. En particular, en los contratos de préstamo sujetos al ámbito de aplicación de la
			Ley 5/2019, de 15 de marzo, reguladora de los contratos de crédito inmobiliario, el ejemplo
			representativo se determinará de conformidad con los criterios establecidos en la letra d) del
			artículo 4.5 de la Orden EHA/1718/2010, de 11 de junio. La hipoteca puede cubrir hasta el 80%
			del precio de la compraventa o del valor de la tasación (el menor de los dos) para la primera
			residencia. Para segundas residencias la hipoteca puede cubrir hasta el 70%. Fórmulas de
			cálculo de cuota e intereses: Cálculo de la cuota mensual:
			<br />
			{renderFormulaCuota()}
			<br />
			Donde: N = capital pendiente del préstamo i = interés nominal expresado en tanto por uno p =
			períodos de amortización en un año t = número de años del período de amortización pendientes
			Fórmula para el cálculo de la parte correspondiente a intereses de la cuota Cálculo de la
			cuota correspondiente a intereses de la cuota:
			<br />
			{renderFormulaInteresCuota()}
			<br />
			Donde: N = capital pendiente del préstamo i = interés nominal expresado en tanto por uno p =
			períodos de amortización en un año En los ejemplos representativos para calcular la cuota del
			primer tramo de 3 años en la hipoteca mixta bonificada, sustituiríamos "N" por 150.000
			(capital inicial de la hipoteca), "i" por 0,0275 (tipo de interés nominal anual de los tres
			primeros años dividido entre 100), "p" por 12 (número de cuotas a pagar al año) y "t" por 30
			(número de años), obteniéndose una cuota de 612,36 euros a pagar cada mes. En el ejemplo
			anterior, la parte correspondiente al pago de intereses de la cuota se calcula sustituyendo
			"N" por 150.000 (capital inicial de la hipoteca), "i" por 0,0275 (tipo de interés nominal
			anual de los tres primeros años dividido entre 100) y "p" por 12 (número de períodos de
			amortización en un año), obteniéndose un importe de 343,75 euros correspondientes a los
			intereses de la cuota del primer mes. El importe restante de la cuota, una vez deducida la
			parte de intereses, es lo que se destina a amortización de capital. En los ejemplos
			representativos para calcular la cuota del primer tramo de 3 años en la hipoteca mixta no
			bonificada, sustituiríamos "N" por 150.000 (capital inicial de la hipoteca), "i" por 0,0365
			(tipo de interés nominal anual de los tres primeros años dividido entre 100), "p" por 12
			(número de cuotas a pagar al año) y "t" por 30 (número de años), obteniéndose una cuota de
			686,19 euros a pagar cada mes. En el ejemplo anterior, la parte correspondiente al pago de
			intereses de la cuota se calcula sustituyendo "N" por 150.000 (capital inicial de la
			hipoteca), "i" por 0,0365 (tipo de interés nominal anual de los tres primeros años dividido
			entre 100) y "p" por 12 (número de períodos de amortización en un año), obteniéndose un
			importe de 456,25 euros correspondientes a los intereses de la cuota del primer mes. El
			importe restante de la cuota, una vez deducida la parte de intereses, es lo que se destina a
			amortización de capital. En los ejemplos representativos, para calcular la cuota del primer
			año en la hipoteca variable bonificada sustituiríamos "N" por 150.000 (capital inicial de la
			hipoteca), "i" por 0,0265 (tipo de interés nominal anual dividido entre 100), "p" por 12
			(número de cuotas a pagar al año) y "t" por 30 (número de años), obteniéndose una cuota de
			604,45 € a pagar cada mes. En el ejemplo anterior, la parte correspondiente al pago de
			intereses de la cuota del primer año se calcula sustituyendo "N" por 150.000 (capital inicial
			de la hipoteca), "i" por 0,0265 (tipo de interés nominal anual dividido entre 100) y "p" por
			12 (número de períodos de amortización en un año), obteniéndose un importe de 331,25 €
			correspondientes a los intereses de la cuota del primer mes. El importe restante de la cuota,
			una vez deducida la parte de intereses, es lo que se destina a amortización de capital. En los
			ejemplos representativos, para calcular la cuota del primer año en la hipoteca variable no
			bonificada sustituiríamos "N" por 150.000 (capital inicial de la hipoteca), "i" por 0,0365
			(tipo de interés nominal anual dividido entre 100), "p" por 12 (número de cuotas a pagar al
			año) y "t" por 30 (número de años), obteniéndose una cuota de 686,19 € a pagar cada mes. En el
			ejemplo anterior, la parte correspondiente al pago de intereses de la cuota del primer año se
			calcula sustituyendo "N" por 150.000 (capital inicial de la hipoteca), "i" por 0,0365 (tipo de
			interés nominal anual dividido entre 100) y "p" por 12 (número de períodos de amortización en
			un año), obteniéndose un importe de 456,25 € correspondientes a los intereses de la cuota del
			primer mes. El importe restante de la cuota, una vez deducida la parte de intereses, es lo que
			se destina a amortización de capital. En los ejemplos representativos, para calcular la cuota
			en la hipoteca fija bonificada sustituiríamos "N" por 150.000 (capital inicial de la
			hipoteca), "i" por 0,0280 (tipo de interés nominal anual dividido entre 100), "p" por 12
			(número de cuotas a pagar al año) y "t" por 30 (número de años), obteniéndose una cuota de
			616,34 € a pagar cada mes. En el ejemplo anterior, la parte correspondiente al pago de
			intereses de la cuota se calcula sustituyendo "N" por 150.000 (capital inicial de la
			hipoteca), "i" por 0,0280 (tipo de interés nominal anual dividido entre 100) y "p" por 12
			(número de períodos de amortización en un año), obteniéndose un importe de 350 €
			correspondientes a los intereses de la cuota del primer mes. El importe restante de la cuota,
			una vez deducida la parte de intereses, es lo que se destina a amortización de capital. En los
			ejemplos representativos, para calcular la cuota en la hipoteca fija no bonificada
			sustituiríamos "N" por 150.000 (capital inicial de la hipoteca), "i" por 0,038 (tipo de
			interés nominal anual dividido entre 100), "p" por 12 (número de cuotas a pagar al año) y "t"
			por 30 (número de años), obteniéndose una cuota de 698,94 € a pagar cada mes. En el ejemplo
			anterior, la parte correspondiente al pago de intereses de la cuota se calcula sustituyendo
			"N" por 150.000 (capital inicial de la hipoteca), "i" por 0,038 (tipo de interés nominal anual
			dividido entre 100) y "p" por 12 (número de períodos de amortización en un año), obteniéndose
			un importe de 475 € correspondientes a los intereses de la cuota del primer mes. El importe
			restante de la cuota, una vez deducida la parte de intereses, es lo que se destina a
			amortización de capital. Sistema de amortización y fórmula de cálculo de amortización de
			principal y de intereses: Para el cálculo de la cuota a pagar se utiliza el sistema de
			amortización francés, que se caracteriza por ser un sistema de cuotas constantes. Es decir, se
			paga la misma cantidad todos los meses, siempre que el tipo de interés aplicable a la
			operación no varíe durante el período de liquidación, o que no se realicen amortizaciones
			anticipadas. La cuota de la hipoteca se compone de una parte de intereses y otra parte de
			amortización del importe total del préstamo. Como la cuota a pagar es constante, a medida que
			se reduce el capital pendiente de la hipoteca, los intereses que se generan sobre este capital
			son inferiores. Por ello, durante los primeros años de la hipoteca, se paga una cantidad mayor
			de intereses que de capital y durante el período final del préstamo se paga más capital y
			menos intereses. Ejemplos representativos: HIPOTECA MIXTA El índice de referencia actual es
			euríbor a 1 año del mes de diciembre de 2023 publicado por el Banco de España a 3 de enero de
			2024: 3,679%. La TAE variable de los siguientes ejemplos ha sido calculada bajo la hipótesis
			de que los índices de referencia no varían, por tanto, esta TAE variable variará con las
			revisiones del tipo de interés, del plazo de amortización y del importe financiado, y su
			revisión será semestral a partir del cuarto año. Para el supuesto que el tipo de interés fijo
			aplicable durante los 3 primeros años sea mayor que el resultante de la suma del diferencial
			pactado y el índice de referencia vigente en la fecha de contratación, se tomará para el
			cálculo de la TAE variable dicho tipo de interés fijo para toda la vida de la operación. Para
			el supuesto que el tipo de interés fijo aplicable durante los 3 primeros años sea menor que el
			resultante de la suma del diferencial pactado y el índice de referencia vigente en la fecha de
			contratación, se tomará para el cálculo de la TAE variable, el tipo fijo del primer período y
			el tipo variable del segundo periodo de interés. 2) HIPOTECA MIXTA BONIFICADA 2,75% TIN tramo
			fijo los 3 primeros años, Euribor +0,60% TIN tramo variable el resto de años. 4,61 % TAE
			variable. Plazo: 30 años (para otros plazos, consulte en su oficina). Cuotas: 36 cuotas de
			612,36 euros/mes, 323 cuotas de 729,07 euros/mes y una última cuota de 728,73 euros. Importe
			total préstamo hipotecario: Importe hipoteca: 150.000 euros. Coste total de la hipoteca:
			126.873,42 euros (108.263,30 euros son intereses). Importe total adeudado: 276.873,42 euros.
			Máxima bonificación: domiciliación de nómina o pensión y contratación de los seguros
			asociados: Seguro Protección Vida Capital Constante y Seguro Protección Hogar con Banco
			Sabadell. 3) HIPOTECA MIXTA NO BONIFICADA 3,65% TIN tramo fijo los 3 primeros años, Euribor
			+1,50% TIN tramo variable el resto de años. 5,28 % TAE variable. Plazo: 30 años (para otros
			plazos, consulte en su oficina). Cuotas: 36 cuotas de 686,19 euros/mes. 323 cuotas de 810,48
			euros/mes y una última cuota de 810,08 euros. Importe total del préstamo hipotecario: 150.000
			euros. Coste total de la hipoteca: 148.302,48 euros (137.297,96 euros son intereses). Importe
			total adeudado: 298.302,48 euros. HIPOTECA VARIABLE El índice de referencia actual es euríbor
			a 1 año del mes de diciembre de 2023 publicado por el Banco de España a 3 de enero de 2024:
			3,679%. La TAE variable de los siguientes ejemplos ha sido calculada bajo la hipótesis de que
			los índices de referencia no varían, por tanto, esta TAE variable variará con las revisiones
			del tipo de interés, del plazo de amortización y del importe financiado, y su revisión será
			semestral a partir del segundo año. Para el supuesto que el tipo de interés fijo aplicable
			durante el primer año sea mayor que el resultante de la suma del diferencial pactado y el
			índice de referencia vigente en la fecha de contratación se tomará para el cálculo de la TAE
			variable dicho tipo de interés fijo para toda la vida de la operación. 4) HIPOTECA VARIABLE
			BONIFICADA 2,65% TIN el primer año, Euribor+0,50% TIN el resto de años. 5,20 % TAE variable.
			Plazo: 30 años (para otros plazos, consulte en su oficina). Cuotas: 12 cuotas de 604,45
			euros/mes. 347 cuotas de 727,93 euros/mes y una última cuota de 725,61 euros. Importe total
			préstamo hipotecario: Importe hipoteca: 150.000 euros. Coste total de la hipoteca: 143.837,94
			euros (110.570,72 euros son intereses). Importe total adeudado: 293.837,94 euros. Máxima
			bonificación: domiciliación de nómina o pensión y contratación de los seguros asociados:
			Seguro Protección Vida Capital Constante, Seguro Protección Hogar y Seguro Protección Total de
			Pagos con Banco Sabadell. 5) HIPOTECA VARIABLE NO BONIFICADA 3,65% TIN el primer año,
			Euribor+1,50% TIN el resto de años. 5,52% TAE variable. Plazo: 30 años (para otros plazos,
			consulte en su oficina). Cuotas: 12 cuotas de 686,19 euros/mes. 347 cuotas de 818,03 euros/mes
			y una última cuota de 822,00 euros. Importe total del préstamo hipotecario: 150.000 euros.
			Coste total de la hipoteca: 153.917,21 euros (142.912,69 euros son intereses). Importe total
			adeudado: 303.917,21 euros. HIPOTECA FIJA La TAE de los siguientes ejemplos representativos
			puede variar en función del plazo de amortización y del importe financiado. 6) HIPOTECA FIJA
			BONIFICADA 2,80% TIN (3,92% TAE). Plazo: 30 años (para otros plazos, consulte en su oficina).
			Cuotas: 359 cuotas de 616,34 euros/mes y una última cuota de 617,37 euros. Importe total
			préstamo hipotecario: 150.000 euros. Coste total de la hipoteca: 103.230,05 euros (71.883,43
			euros son intereses). Importe total adeudado: 253.230,05 euros. Máxima bonificación:
			domiciliación de nómina o pensión y contratación de los seguros asociados: Seguro Protección
			Vida Capital Constante, Seguro Protección Hogar y Seguro Protección Total de Pagos con Banco
			Sabadell. 7) HIPOTECA FIJA NO BONIFICADA 3,80% TIN (4,24% TAE) Plazo: 30 años (para otros
			plazos, consulte en su oficina). Cuotas: 359 cuotas de 698,94 euros/mes y una última cuota de
			696,36 euros. Importe total del préstamo hipotecario: 150.000 euros. Coste total de la
			hipoteca: 112.620,34 euros (101.615,82 euros son intereses). Importe total adeudado:
			262.620,34 euros. 2) ¿Qué incluye el cálculo de la TAE variable? Comisión de apertura: 0 euros
			(0%). Importe total de los intereses de la hipoteca: 101.615,82 euros. Contratación Cuenta
			Relación: 50 euros/trimestre. Seguro Protección Hogar: el coste por contratar este seguro que
			incluye la cobertura de daños a través de Banco Sabadell, es de 12,99 euros/mes. El coste de
			este seguro variará en función del momento de la contratación y, entre otros factores, de las
			características de la finca a hipotecar, capital asegurado y garantías contratadas. El importe
			mostrado es meramente orientativo tomando como ejemplo un préstamo hipotecario cuyo capital
			asciende a 150.000 euros y para continente de 100.000,00 euros cuya tipología de vivienda es
			un piso intermedio con una superficie de 100 m2 construidos. Costes de comprobación registral:
			25,41 euros. Costes de tasación: 302,71 euros. 2) y 4) En cuanto al tramo variable, se
			realizará una revisión semestral teniendo en cuenta la fecha en que se contrató la hipoteca.
			En ella, se revisarán los productos susceptibles de bonificación que tenga el cliente
			contratado, así como el Euríbor a aplicar. 3) y 5) En cuanto al tramo variable se realizará
			una revisión semestral del Euríbor a aplicar. 4) y 6) ¿Qué incluye el cálculo de la TAE
			variable y TAE? Comisión de apertura: 0 euros (0%). Importe total de los intereses de la
			hipoteca: 110.570,72 euros para la hipoteca variable bonificada y 71.883,43 euros para la
			hipoteca fija bonificada. Contratación Cuenta Relación: 50 euros/trimestre. Seguro Protección
			Hogar: el coste por contratar este seguro que incluye la cobertura de daños a través de Banco
			Sabadell, es de 12,99 euros/mes. El coste de este seguro variará en función del momento de la
			contratación y, entre otros factores, de las características de la finca a hipotecar, capital
			asegurado y garantías contratadas. El importe mostrado es meramente orientativo tomando como
			ejemplo un préstamo hipotecario cuyo capital asciende a 150.000 euros y para continente de
			100.000,00 euros cuya tipología de vivienda es un piso intermedio con una superficie de 100 m2
			construidos. Seguro de vida de capital constante con prima trimestral a mantener durante toda
			la vida de la hipoteca: 63,38 euros/trimestre (ejemplo para un hombre de 30 años). Seguro
			Protección Total de Pagos de prima anual a mantener durante toda la vida de la hipoteca:
			488,57€/año para la hipoteca variable bonificada y 424,55€/año para la hipoteca fija
			bonificada. Con cobertura del 100 % de la cuota de la hipoteca en caso de encontrarse en
			situación de desempleo o en situación de baja laboral (ejemplo para un trabajador por cuenta
			ajena con contrato indefinido). Costes de comprobación registral: 25,41 euros. Costes de
			tasación: 302,71 euros. Se hará una revisión semestral de la contratación de los productos a
			los que se condiciona el tipo de interés aplicable en caso de contratar la hipoteca con
			bonificación. 3) 5) y 7) ¿Qué incluye el cálculo de la TAE variable y TAE? Comisión de
			apertura: 0 euros (0%). Importe total de los intereses de la hipoteca: 137.297,96 euros para
			la hipoteca mixta no bonificada, 142.912,69 euros para la hipoteca variable no bonificada y
			101.615,82 euros para la hipoteca fija no bonificada Contratación Cuenta Relación: 50
			euros/trimestre. Seguro de daños obligatorio durante toda la vida de la hipoteca (no es
			necesario contratarlo con Banco Sabadell): Banco Sabadell no comercializa un seguro que sólo
			incluya la cobertura de daños, por tanto el cálculo de la TAE y TAE variable se ha realizado
			teniendo en cuenta la prima resultante de simular el seguro de Protección hogar de Banco
			Sabadell (que incluye la cobertura de daños) cuyo coste se ha estimado en 12,99 euros/mes. El
			coste de este seguro variará en función del momento de la contratación y, entre otros
			factores, de las características de la finca a hipotecar, capital asegurado y garantías
			contratadas. El importe mostrado es meramente orientativo tomando como ejemplo un préstamo
			hipotecario cuyo capital asciende a 150.000 euros y para continente de 100.000,00 euros cuya
			tipología de vivienda es un piso intermedio con una superficie de 100 m2 construidos. Costes
			de comprobación registral: 25,41 euros. Costes de tasación: 302,71 euros. Diferencias entre
			oferta de productos combinada y por separado: La oferta de productos combinada o por separado
			tendrá afectación en los costes I y la cancelación anticipada II del préstamo o de sus
			productos combinados. I) Costes. El coste de la contratación del seguro de Protección Hogar,
			Vida Capital Constante y Protección Total de Pagos es independiente a la contratación del
			préstamo, por lo que tiene el mismo coste que si se contrata de forma individual. II) Efectos
			de la cancelación anticipada del préstamo o cualquiera de los productos combinados. Los
			efectos que la cancelación anticipada del préstamo o cualquiera de los productos combinados
			produciría sobre el coste conjunto del préstamo y el resto de los productos o servicios
			combinados formarán parte de la información personalizada que se facilitará mediante la Ficha
			Europea de Información Normalizada (FEIN) Información adicional: Ejemplos representativos de
			préstamo con garantía hipotecaria sobre inmuebles de uso residencial destinado a financiar la
			compra de vivienda por personas físicas que actúan como consumidoras. Operación sujeta a
			previa aprobación por Banco Sabadell. No se presta el servicio de asesoramiento. Condiciones
			de tipo de interés sujetas a análisis de riesgo por parte de Banco Sabadell. Estas condiciones
			pueden variar en función del resultado del análisis de riesgo. De conformidad con el artículo
			1911 del Código Civil, que consagra el principio de responsabilidad universal, en caso de
			impago, el deudor, y, en su caso, sus fiadores o avalistas solidarios y garantes hipotecarios,
			responderán con todos sus bienes presentes y futuros, pudiendo llegar a perder su/s vivienda/s
			y/o cualesquiera otros bienes de su propiedad. Información adicional sobre los seguros
			asociados a tu hipoteca: Protección Hogar y Protección Total Pagos son seguros de BanSabadell
			Seguros Generales, S.A. de Seguros y Reaseguros, con NIF A64194590 y domicilio en la calle
			Isabel Colbrand, 22, 28050 Madrid, inscrita en el Registro Mercantil de Madrid y en el
			Registro de Entidades Aseguradoras de la DGSyFP con clave n.º C-0767. Protección Vida Capital
			Constante son seguros de BanSabadell Vida, Sociedad Anónima de Seguros y Reaseguros, con NIF
			A08371908 y domicilio en la calle Isabel Colbrand, 22, 28050 Madrid, inscrita en el Registro
			Mercantil de Madrid y en el Registro de Entidades Aseguradoras de la DGSyFP con clave n.º
			C-0557. Seguros mediados por BanSabadell Mediación, Operador de Banca-Seguros Vinculado del
			Grupo Banco Sabadell, S.A., NIF A-03424223, con domicilio en avda. Óscar Esplá, 37, 03007
			Alicante, inscrita en el Registro Mercantil de Alicante y en el Registro Administrativo
			Especial de Mediadores de Seguros de la DGSyFP con clave n.º OV-0004, teniendo suscrito un
			seguro de responsabilidad civil conforme a lo dispuesto en la normativa de distribución de
			seguros y reaseguros privados vigente en cada momento. Puedes consultar las entidades
			aseguradoras con las que BanSabadell Mediación ha celebrado un contrato de agencia de seguros
			en la web
			<a
				href="https://www.bancosabadell.com/bsmediacion"
				target="_blank"
				style={{ color: '#004799' }}>
				www.bancosabadell.com/bsmediacion.
			</a>
			Consulta{' '}
			<a
				style={{ color: '#004799' }}
				href="https://www.bancsabadell.com/cs/Satellite?c=GBS_Texto&cid=6000047221086&pagename=SabAtl/GBS_Texto/GBS_popupCondiciones"
				target="_blank">
				aquí{' '}
			</a>
			la información del Mediador del Seguro.
		</span>
	);
};

export default CondictionsLegal;
